import React, { useState } from "react";
import api from "../lib/api";
import { formatErr } from "../lib/auth";
import { ArrowRight, MapPin, Mail, Check } from "lucide-react";

export default function Contact() {
  const [form, setForm] = useState({
    first_name: "", last_name: "", email: "", phone: "", service: "", message: ""
  });
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      await api.post("/contact", form);
      setSent(true);
    } catch (e) {
      setErr(formatErr(e));
    } finally { setLoading(false); }
  };

  return (
    <section className="section hero-radial min-h-[80vh]">
      <div className="container-if grid md:grid-cols-2 gap-12 items-start">
        <div>
          <div className="font-mono-label text-[var(--if-gold)] mb-3">Contact HQ</div>
          <h1 className="font-display text-[44px] md:text-[64px] leading-[0.95] mb-4">
            Send us a <span className="italic text-[var(--if-gold)]">message</span>.
          </h1>
          <p className="text-[rgba(35,38,28,0.7)] mb-8 max-w-md">
            Questions before booking? We respond within 24 hours. No automated replies — a real human from the team will get back to you.
          </p>
          <div className="flex flex-col gap-4 text-sm">
            <span className="flex items-center gap-3"><MapPin className="w-4 h-4 text-[var(--if-gold)]" /> Based in Texas · Serving the U.S.</span>
            <span className="flex items-center gap-3"><Mail className="w-4 h-4 text-[var(--if-gold)]" /> hq@infantry-financial.com</span>
          </div>
        </div>

        {sent ? (
          <div className="card-cream p-10 text-[var(--if-ink)]" data-testid="contact-success">
            <div className="w-12 h-12 rounded-full bg-[var(--if-olive)] flex items-center justify-center mb-5">
              <Check className="w-6 h-6 text-[var(--if-cream)]" />
            </div>
            <h2 className="font-display text-3xl mb-2">Message received.</h2>
            <p className="text-[rgba(27,29,25,0.7)]">We'll be in touch within 24 hours. In the meantime, feel free to <a href="/booking" className="underline">book a free consultation</a>.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="card-dark p-7 flex flex-col gap-4">
            <div className="grid grid-cols-2 gap-3">
              <input required className="if-input" placeholder="First name" value={form.first_name}
                onChange={(e) => setForm({ ...form, first_name: e.target.value })} data-testid="contact-first-name" />
              <input required className="if-input" placeholder="Last name" value={form.last_name}
                onChange={(e) => setForm({ ...form, last_name: e.target.value })} data-testid="contact-last-name" />
            </div>
            <input required type="email" className="if-input" placeholder="Email" value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="contact-email" />
            <input className="if-input" placeholder="Phone (optional)" value={form.phone}
              onChange={(e) => setForm({ ...form, phone: e.target.value })} data-testid="contact-phone" />
            <input className="if-input" placeholder="Service of interest (optional)" value={form.service}
              onChange={(e) => setForm({ ...form, service: e.target.value })} data-testid="contact-service" />
            <textarea required className="if-input" rows={5} placeholder="How can we help?" value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })} data-testid="contact-message" />

            {err && <div className="text-red-400 text-sm">{err}</div>}
            <button type="submit" disabled={loading} className="btn-gold justify-center" data-testid="contact-submit">
              {loading ? "Sending…" : <>Send Message <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>
        )}
      </div>
    </section>
  );
}
